var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInsploreBoard = function SvgInsploreBoard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    stroke: "#171717",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.634 1.629a.8.8 0 0 0-.234.565v8.812a.8.8 0 0 0 .8.8h6.4a.8.8 0 0 0 .8-.8v-8.8a.8.8 0 0 0-.8-.8l-6.4-.012a.8.8 0 0 0-.566.235ZM19 1.394l-6.4.012a.8.8 0 0 0-.8.8v4a.8.8 0 0 0 .8.8H19a.8.8 0 0 0 .8-.8V2.194a.8.8 0 0 0-.8-.8ZM9.166 19.571a.8.8 0 0 0 .234-.565v-4a.8.8 0 0 0-.8-.8H2.2a.8.8 0 0 0-.8.8v3.988a.8.8 0 0 0 .8.8l6.4.01a.8.8 0 0 0 .566-.233ZM19 9.406h-6.4a.8.8 0 0 0-.8.8v8.8a.8.8 0 0 0 .8.8l6.4-.01a.8.8 0 0 0 .8-.8v-8.79a.8.8 0 0 0-.8-.8Z"
  }))));
};
export default SvgInsploreBoard;